import { doHttp } from '../utils/common'
import { HTTP_TYPE_POST, CONTENT_TYPE_FILE } from '../utils/config'

/**
 * 上传
 * @param params
 * @return {*}
 */
export function apiUpload (params) {
  if (params) {
    return doHttp('/file/upload.api', HTTP_TYPE_POST, params, CONTENT_TYPE_FILE)
  } else {
    return new Promise(function(resolve, reject) {
      resolve({ data: '' })
    })
  }
}
